import { RouteConfig } from 'vue-router';
import { importPage } from '@/utils/import';

export const routes: RouteConfig[] = [
  { path: '/vip', component: importPage('vip/vip') },
  { path: '/vip/register', component: importPage('vip/register') },
  { path: '/vip/pay', component: importPage('vip/pay') },
  { path: '/vip/pay-list', component: importPage('vip/pay-list') },
  { path: '/vip/pay-list1', component: importPage('vip/pay-list1') },
  { path: '/vip/park-room', component: importPage('vip/park-room') },
  { path: '/vip/park-amap', component: importPage('vip/park-amap') },
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/routers/vip.ts